
export const leonMediaArray = [
  {
    _id: 'leonMediaId1',
    userId: 'leonUserId',
    email: 'leon@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-1-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `#MondaysAmIRight?`,
      `My best blue steel`
    ],
    subcaptions: [
      `Negotiating down the plumber's ridiculous estimate`,
      `My "about to tap that ass" face`,
      `The intense look is because I know I'm about to tap that ass`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'leonMediaId2',
    userId: 'leonUserId',
    email: 'leon@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-2-p.png`,
    description: ``,
    captions: [
      `I'm known for`,
      `How history will remember me`,
      `My life behind the scenes`
    ],
    subcaptions: [
      `Peanut butter straight from the jar like`,
      `OK, had my breakfast, time to start lampin`,
      `Tappin the peanut butter as a warmup to tappin that ass`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'leonMediaId3',
    userId: 'leonUserId',
    email: 'leon@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-3-p.png`,
    description: ``,
    captions: [
      `Plandid or candid?`,
      `Life outtake`,
      `Dating me will look like`
    ],
    subcaptions: [
      `Let's pretend I'm thinking something profound`,
      `Should I be wearing glasses to trick people into thinking I look smart`,
      `Weddings, an excuse to eat cake`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'leonMediaId4',
    userId: 'leonUserId',
    email: 'leon@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-4-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `I'm known for`,
      `Woke up like this`
    ],
    subcaptions: [
      `Nothin but big gulps from this big Johnson`,
      `Pre-asstappin hydration`,
      `Hope you like Big Gulps cuz I'm more than just a sip`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'leonMediaId5',
    userId: 'leonUserId',
    email: 'leon@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-5-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `Nothin but big gulps from this big Johnson`,
      `Pre-asstapping hydration`,
      `Hope you like Big Gulps cuz I'm more than just a sip`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'leonMediaId6',
    userId: 'leonUserId',
    email: 'leon@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-6-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `Go on, try to find an asymmetry`,
      `See, I can look nice when I try` 
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'leonMediaId7',
    userId: 'leonUserId',
    email: 'leon@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-7-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `My uniform`,
      `My best blue steel`
    ],
    subcaptions: [
      `My "about to tap that ass" face`,
      `My "about to tap that ass" outfit`,
      `About to bring the ruckus`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'leonMediaId8',
    userId: 'leonUserId',
    email: 'leon@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-8-p.png`,
    description: ``,
    captions: [
      `Caught in the act`,
      `Me in my blogging days`,
      `I'm known for`
    ],
    subcaptions: [
      `Post asstap energy`,
      `Post ruckus energy`,
      `Post tap energy`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'leonMediaId9',
    userId: 'leonUserId',
    email: 'leon@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-9-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `Leave a one-word review for this`,
      `Lowkey flex`
    ],
    subcaptions: [
      `Tree pose looking for his bird of paradise`,
      `Options include 'masculine', 'virile', and 'beguiling'`,
      `Come over for some downward dogs`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'leonMediaId10',
    userId: 'leonUserId',
    email: 'leon@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-10-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-10-p.png`,
    description: ``,
    captions: [
      `I can teach you how to`,
      `Leave a one-word review for this`,
      `Lowkey flex`
    ],
    subcaptions: [
      `Proof that I can blend in with white people`,
      `Options include 'masculine', 'virile', and 'beguiling'`,
      `Showing I can mix with white people`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'leonMediaId11',
    userId: 'leonUserId',
    email: 'leon@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-11-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-leon-11-p.png`,
    description: ``,
    captions: [
      `#MondaysAmIRight?`,
      `Pre-coffee me`,
      `Life outtake`
    ],
    subcaptions: [
      `On a quest to find the best coffee beans in Mexico`,
      `Hold on, mid-scheme`,
      `Showing I can mix with white people`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]